import {
  FacebookFilled,
  InstagramFilled,
  MailOutlined,
  PhoneOutlined,
  WhatsAppOutlined,
} from '@ant-design/icons';
import {Button, Divider, Image} from 'antd';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';

const FooterScreen = ({data}) => {
  return (
    <footer className={'w-full bg-primary-800 text-white flex flex-col items-center py-6 lg:px-20 px-4 mt-auto'}>
      <div className={'w-full max-w-7xl'}>
        <div className={' grid grid-cols-1 lg:grid-cols-3 gap-6 items-center justify-center text-base'}>
          {/* Logo Section */}
          <div className={'flex justify-center'}>
            <div className={'w-[150px] lg:w-[120px]'}>
              <Link to={'/'}>
                <Image
                  src={data.image}
                  alt={'logo'}
                  className={'image-fill'}
                  preview={false}
                />
              </Link>
            </div>
          </div>

          {/* Contact Section */}
          <div className={'flex flex-col items-center justify-center text-center '}>
            <Link className={'lg:text-xl text-lg font-semibold mb-2'} to={'/contact'}>
                Contact Us
            </Link>
            <div className={'flex items-center gap-2 text-md mb-1'}>
              <PhoneOutlined rotate={90} className={'text-blue-400 text-lg'} />
              <p>{data.phone_no}</p>
            </div>
            <Link to={'https://www.gmail.com'} target={'_blank'}>
              <div className={'flex items-center gap-2 text-md'}>
                <MailOutlined className={'text-red-500 text-lg'} />
                <p>{data.email}</p>
              </div>
            </Link>
          </div>

          {/* Social Links */}
          <div className={'flex justify-center  gap-5'}>
            <Link to={data.facebookLink} target={'_blank'}>
              <FacebookFilled className={'text-blue-600 text-3xl hover:scale-110 transition-transform duration-300'} />
            </Link>
            <Link to={data.instagramLink} target={'_blank'}>
              <InstagramFilled className={'text-pink-600 text-3xl hover:scale-110 transition-transform duration-300'} />
            </Link>
            <Link to={data.whatsappLink} target={'_blank'}>
              <WhatsAppOutlined className={'text-green-500 text-3xl hover:scale-110 transition-transform duration-300'} />
            </Link>
          </div>
        </div>
      </div>

      <Divider className={'bg-white/20 my-5 w-full max-w-7xl'} />

      {/* Bottom Section */}
      <div className={'w-full max-w-7xl flex flex-col lg:flex-row justify-between items-center gap-2 text-sm text-center'}>
        <Button type={'link'} className={'!text-white !p-0 hover:underline'}>
          All rights reserved - Ratnaparkhi Jewellers
        </Button>
        <Link to={'terms'}>
          <Button type={'link'} className={'!text-white !p-0 hover:underline'}>
            Terms and Conditions
          </Button>
        </Link>
        <div className={'opacity-80'}>
          Powered By - Ascensify Technologies Kolhapur
        </div>
      </div>
    </footer>
  );
};

FooterScreen.propTypes = {
  data: PropTypes.shape,
};

export default FooterScreen;
